import anime from 'animejs/lib/anime.es.js';
import { getReducedMotion } from '../../utils/animation';
import { all, one } from '../../utils/dom';
import { ScrollTrigger } from '../scroll-trigger';

export function HeroCrossSell() {
	all('.c-hero-x-sell').forEach(element => {
		let style = window.getComputedStyle(element);
		let mediaQueryString = style.getPropertyValue('--parallax');

		if (!mediaQueryString || getReducedMotion()) {
			return;
		}

		let mediaQuery = window.matchMedia(mediaQueryString);
		let content = one('.c-hero-x-sell__content', element);

		let parallax = anime({
			targets: content,
			autoplay: false,
			duration: 100,
			easing: 'linear',
			translateY: ['100%', '-100%'],
		});

		let trigger = ScrollTrigger(element, {
			onUpdate(entry) {
				parallax.seek(entry.progress * parallax.duration);
			},
		});

		testMq();
		mediaQuery.addListener(testMq);

		function testMq() {
			if (mediaQuery.matches) {
				return trigger.enable();
			}

			trigger.disable();
			// Halfway the translate will 0.
			parallax.seek(0.5 * parallax.duration);
		}
	});
}
